module.exports = __webpack_public_path__ + "web_static/img/chatbot01.ee823655.png";